export default "__VITE_ASSET__ba7b8128__"